import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH.
export default function AuthCallback({ onSuccess }) {
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setError("No session_id found in URL");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        await api.googleSessionExchange(sessionId);
        // strip the hash and go home
        window.history.replaceState({}, "", "/");
        onSuccess && onSuccess();
      } catch (e) {
        setError(e.response?.data?.detail || e.message || "Sign-in failed");
      }
    })();
  }, [onSuccess]);

  return (
    <div className="login-wrap">
      <div className="login-card" style={{ textAlign: "center" }}>
        {error ? (
          <>
            <div className="form-error" data-testid="cb-error">{error}</div>
            <button
              className="btn-primary"
              style={{ marginTop: 16 }}
              onClick={() => { window.location.href = "/"; }}
            >Back to sign in</button>
          </>
        ) : (
          <div className="loading-row" style={{ padding: 30 }}>
            <span className="spinner" /> Finishing Google sign-in…
          </div>
        )}
      </div>
    </div>
  );
}
